import rhttoast from 'react-hot-toast';

import { v4 as uuid } from 'uuid';

type ToastProps = { title?: string; message: string };

type ToastMethods = {
  error: (props: ToastProps) => void;
  success: (props: ToastProps) => void;
};

const toast: ToastMethods = {
  error: ({ title, message }) => rhttoast.error(`${title || 'ERROR'} | ${message}`, { id: uuid() }),
  success: ({ title, message }) =>
    rhttoast.success(`${title || 'SUCCESS'} | ${message}`, { id: uuid() })
};

export default toast;
